<template>
    <!-- 病史选择 -->
    <div class="checkbox-group">
        <div class="checkbox" :class="{ active: onInArray(item) }" v-for="(item, index) in options" :key="index" @click="onChange(item)">{{ item }}</div>
        <div class="checkbox checkbox-input" v-if="onInArray('其他')">
            <input class="input" v-model="other" placeholder="请输入其他" @change="onInput" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: String,
        options: {
            type: Array,
            default: () => []
        },
        multiple: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            active: [],
            other: ''
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            let selected = this.value ? this.value.split('|') : [];
            let list = this.options;
            let active = [];
            for (let i = 0; i < selected.length; i++) {
                let checked = list.some((item) => item == selected[i]);
                if (checked) {
                    active.push(selected[i]);
                } else if (selected[i]) {
                    this.other = selected[i];
                    active.push('其他');
                }
            }
            if (!(!active.length && this.active.length == 1 && this.active[0] == '其他')) {
                this.active = active;
            }
        },
        onInArray(name, isIndex) {
            let list = this.active;
            for (let i = 0; i < list.length; i++) {
                if (name == list[i]) return isIndex ? i : true;
            }
            return isIndex ? -1 : false;
        },
        onChange(name) {
            let index = this.onInArray(name, true);
            if (index == -1) {
                if (name == '暂无') {
                    this.active = ['暂无'];
                    this.other = '';
                } else {
                    if (!this.multiple) {
                        this.active = [];
                    } else {
                        let idx = this.onInArray('暂无', true);
                        if (idx != -1) {
                            this.active.splice(idx, 1);
                        }
                    }
                    this.active.push(name);
                }
            } else {
                this.active.splice(index, 1);
            }
            this.onInput();
        },
        onInput() {
            let selected = [];
            let list = this.options;
            for (let i = 0; i < list.length; i++) {
                if (this.onInArray(list[i]) && list[i] != '其他') {
                    selected.push(list[i]);
                }
            }
            if (this.onInArray('其他') && this.other) {
                selected.push(this.other);
            }
            this.$emit('input', selected.join('|'))
        }
    },
    watch: {
        options: 'init',
        value: 'init'
    }
}
</script>
<style lang="scss" scoped>
.checkbox-group {
    display: flex;
    flex-wrap: wrap;
    margin-left: -10px;
    margin-top: -10px;

    .checkbox {
        border: 1px solid #ddd;
        color: #888;
        padding: 0 20px;
        border-radius: 50px;
        margin-left: 10px;
        margin-top: 10px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        overflow: hidden;
        cursor: pointer;

        &.active {
            border-color: #3481f4;
            color: #3481f4;
        }

        &.checkbox-input {
            padding: 0;

            .input {
                border: none;
                height: 100%;
                padding: 0 10px;
                width: 150px;
            }
        }
    }
}
</style>